export const options = [
    {
        label: "Option 1",
        value: "Option 1"
    },
    {
        label: "Option 2",
        value: "Option 2"
    },
]